/* AVADACHI cart drawer extras: upsell add-to-cart + discount codes.
   Uses delegated listeners so it keeps working after the drawer re-renders. */
(() => {
  if (window.__avdCartExtras) return;
  window.__avdCartExtras = true;

  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  const json = { 'Content-Type': 'application/json', Accept: 'application/json' };

  const drawer = () => document.querySelector('cart-drawer');

  const rerender = (state) => {
    const d = drawer();
    if (!d || !state || !state.sections) return;
    if (d.classList.contains('is-empty')) d.classList.remove('is-empty');
    d.renderContents(state);
  };

  const setMsg = (text, isError) => {
    const msg = document.querySelector('[data-avd-discount-msg]');
    if (!msg) return;
    msg.textContent = text || '';
    msg.classList.toggle('is-error', !!isError);
  };

  const currentCodes = async () => {
    const cart = await fetch(`${window.routes?.cart_url || '/cart'}.js`, { headers: json }).then((r) => r.json());
    return (cart.discount_codes || []).filter((c) => c.applicable).map((c) => c.code);
  };

  const updateDiscounts = (codes) =>
    fetch(`${window.routes?.cart_update_url || '/cart/update'}.js`.replace('.js.js', '.js'), {
      method: 'POST',
      headers: json,
      body: JSON.stringify({ discount: codes.join(','), sections: SECTIONS }),
    }).then((r) => r.json());

  document.addEventListener('click', async (event) => {
    /* ---- Upsell: + Add ---- */
    const addBtn = event.target.closest('[data-avd-upsell-add]');
    if (addBtn) {
      event.preventDefault();
      const card = addBtn.closest('[data-avd-upsell]');
      const variantEl = card && card.querySelector('[data-avd-upsell-variant]');
      if (!variantEl || !variantEl.value) return;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      try {
        const res = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`.replace('.js.js', '.js'), {
          method: 'POST',
          headers: json,
          body: JSON.stringify({ items: [{ id: Number(variantEl.value), quantity: 1 }], sections: SECTIONS }),
        });
        const state = await res.json();
        if (!res.ok || state.status) throw new Error(state.description || state.message || 'Could not add');
        rerender(state);
      } catch (e) {
        addBtn.disabled = false;
        addBtn.textContent = 'Sold out';
        setTimeout(() => (addBtn.textContent = '+ Add'), 1800);
      }
      return;
    }

    /* ---- Discount: Apply ---- */
    const applyBtn = event.target.closest('[data-avd-discount-apply]');
    if (applyBtn) {
      event.preventDefault();
      const input = document.querySelector('[data-avd-discount-input]');
      const code = (input && input.value || '').trim();
      if (!code) {
        setMsg('Enter a discount code', true);
        return;
      }
      applyBtn.disabled = true;
      applyBtn.textContent = '…';
      setMsg('');
      try {
        const existing = await currentCodes();
        if (existing.map((c) => c.toLowerCase()).includes(code.toLowerCase())) {
          setMsg('That code is already applied');
          return;
        }
        const state = await updateDiscounts([...existing, code]);
        const entry = (state.discount_codes || []).find((c) => c.code.toLowerCase() === code.toLowerCase());
        if (!entry || !entry.applicable) {
          // Drop the invalid code so it doesn't linger on the cart.
          const cleaned = await updateDiscounts(existing);
          rerender(cleaned);
          setMsg(`"${code}" isn't valid for this order`, true);
          return;
        }
        rerender(state);
        setMsg(`"${entry.code}" applied`);
      } catch (e) {
        setMsg('Something went wrong, please try again', true);
      } finally {
        const btn = document.querySelector('[data-avd-discount-apply]');
        if (btn) {
          btn.disabled = false;
          btn.textContent = 'Apply';
        }
      }
      return;
    }

    /* ---- Discount: remove chip ---- */
    const removeBtn = event.target.closest('[data-avd-discount-remove]');
    if (removeBtn) {
      event.preventDefault();
      const code = removeBtn.getAttribute('data-avd-discount-remove');
      removeBtn.disabled = true;
      try {
        const existing = await currentCodes();
        const state = await updateDiscounts(existing.filter((c) => c.toLowerCase() !== code.toLowerCase()));
        rerender(state);
      } catch (e) {
        removeBtn.disabled = false;
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && event.target.matches && event.target.matches('[data-avd-discount-input]')) {
      event.preventDefault();
      const btn = document.querySelector('[data-avd-discount-apply]');
      if (btn) btn.click();
    }
  });
})();
